import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { BASE_PROJECT_PATH, generateRoutePath } from '@/src/routes';

import { TeamMember } from '../types';

const url = `${PREFIX_URL}${BASE_PROJECT_PATH}/getInternalTeam`;

type TeamMembersResponse = {
  users: TeamMember[];
};

export const getTeamMembers = (params): Promise<TeamMembersResponse> => {
  return axios.get(generateRoutePath(url, { projectId: params.projectId }), {
    params,
    showError: false,
  });
};

export const teamMemberKeys = {
  list: ['TeamMembers'] as const,
};

type QueryFnType = typeof getTeamMembers;

type useTeamMembersOptions = {
  projectId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useTeamMembers = ({ projectId, config }: useTeamMembersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...teamMemberKeys.list, projectId],
    queryFn: () => getTeamMembers({ projectId }),
    staleTime: Infinity,
    ...config,
  });
};
